import { useDroppable } from "@dnd-kit/core"
import { green } from "@ant-design/colors"

const PromoteWorkareaDroppable = () => {
  const { setNodeRef, isOver } = useDroppable({ id: 'promote-workarea', data: { type: 'promote-workarea' } })
  const style: React.CSSProperties = {
    borderWidth: '2px',
    borderStyle: 'dashed',
    borderColor: isOver ? green.primary : '#e9e9e9',
    borderRadius: '5px',
    padding: '32px',
    marginBottom: '5px',
  }

  return <div style={style} ref={setNodeRef}>Remove workarea from group</div>
}

export default PromoteWorkareaDroppable
